import React from 'react'

type Props = {
  className?: string
  fill?: string
  size?: string
}

const Information = ({ className, fill, size, ...rest }: Props) => (
  <svg
    className={className}
    fill={fill}
    height={size}
    viewBox='0 0 32 32'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    <path d='M15.9997 1.33337C7.90367 1.33337 1.33301 7.90404 1.33301 16C1.33301 24.096 7.90367 30.6667 15.9997 30.6667C24.0957 30.6667 30.6663 24.096 30.6663 16C30.6663 7.90404 24.0957 1.33337 15.9997 1.33337ZM17.4663 23.3334H14.533V14.5334H17.4663V23.3334ZM17.4663 11.6H14.533V8.66671H17.4663V11.6Z' />
  </svg>
)

Information.defaultProps = {
  fill: '#98A1B2',
  size: '32'
}

export default Information
